



  import { Component } from 'vue-property-decorator'
  import { mixins } from 'nuxt-property-decorator'
  import CurrentProductMixin from '~/mixins/CurrentProduct'

  @Component({
    components: {
      OneEuEnergyLabel: () => import('~/components/organisms/product/OneEuEnergyLabel.vue'),
    },
  })
  export default class OneProductTechnicalDataSection extends mixins<CurrentProductMixin>(CurrentProductMixin) {}
